import {COURSES_SET_LIST, COURSES_CHOOSE, COURSES_CANCELCHOOSE, COURSES_SEARCHING} from '../constants/actionTypes';
//import {ERR_COMMUNICATION, ERR_UNKNOWN} from '../constants/errors';
import {fetchMB} from '../utils/MojBus'
//import {error, errorDesc} from './userActions'
import {errorDesc} from './userActions'

export function setCourseList(courses, filter){
  return {
    type: COURSES_SET_LIST,
    courses,
    filter
  }
}

export function setSearchState(){
  return {
    type: COURSES_SEARCHING,
  }
}

export function setCourse(courseIndex){
  return {
    type: COURSES_CHOOSE,
    courseIndex
  }
}
export function cancelCourse(){
  return {
    type: COURSES_CANCELCHOOSE,
  }
}

export function fetchCourses(apiRequest){
  return dispatch => {
    // let funcError=function(errorNo){
    //   return dispatch(error(ERR_UNKNOWN))
    // }
    //apiRequest.agentLogin=agentLogin;

    // alert('Search courses ' + JSON.stringify(apiRequest));
    fetchMB('search', apiRequest, true)
    .then(
      function(json){
        if (json.status==='OK'){
          return dispatch(setCourseList(json.courses, apiRequest))
        }
        else{
          return dispatch(errorDesc(json.errorMessage))
        }
          //funcError()
      },
      function(errDesc){
        return dispatch(errorDesc(errDesc))
        // return dispatch(error(ERR_COMMUNICATION))
      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/actions/coursesActions.js